(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-hero-track]');
    var slides = carousel.querySelectorAll('[data-hero-slide]');
    var dots = carousel.querySelectorAll('[data-hero-dot]');
    var prev = carousel.querySelector('[data-hero-prev]');
    var next = carousel.querySelector('[data-hero-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;
    var autoplay = carousel.dataset.autoplay === 'true';
    var duration = (parseInt(carousel.dataset.autoplayDuration, 10) || 7) * 1000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      slides.forEach(function (slide, s) {
        slide.setAttribute('aria-hidden', s === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, d) {
        dot.classList.toggle('is-active', d === index);
        if (d === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || reducedMotion) return;
      stop();
      timer = setInterval(function () {
        goTo(index + 1);
      }, duration);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    var touchStartX = null;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 50) {
        goTo(delta < 0 ? index + 1 : index - 1);
      }
      touchStartX = null;
      start();
    }, { passive: true });

    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speedaxle-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sa-popup]').forEach(function (popup) {
    var STORAGE_KEY = 'sa_popup_dismissed_at';
    var reshowMs = (parseInt(popup.dataset.reshowDays, 10) || 14) * 86400000;
    var delayMs = (parseInt(popup.dataset.delay, 10) || 3) * 1000;
    var lastFocus = null;

    function storageGet() {
      try {
        return parseInt(window.localStorage.getItem(STORAGE_KEY), 10) || 0;
      } catch (e) {
        return 0;
      }
    }

    function storageSet() {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {
        /* private mode - show-once falls back to per-pageview */
      }
    }

    function open() {
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = popup.querySelector('.sa-popup__x');
      if (x) x.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close(remember) {
      popup.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (remember) storageSet();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close(true);
    }

    popup.querySelectorAll('[data-sa-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(true); });
    });
    var cta = popup.querySelector('[data-sa-popup-cta]');
    if (cta) {
      cta.addEventListener('click', function () { close(true); });
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(popup)) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(popup)) close(false);
      });
      return;
    }

    if (Date.now() - storageGet() < reshowMs) return;
    setTimeout(open, delayMs);
  });

  } catch(e) { console.error(e); }
})();
})();
